import { List } from '@tribeplatform/react-ui-kit/Layout'

export const LoadingList = () => {
  return (
    <List direction="vertical" spacing="md">
      {[...Array(9).keys()].map(key => (
        <List.Item key={key} className="flex items-center space-s-3">
          <div className="rounded-avatar bg-skeleton h-8 w-8" />
          <div className="h-5 bg-skeleton rounded-full flex-1" />
        </List.Item>
      ))}
    </List>
  )
}
